import { render } from "./ExpertStatisticsTemplate.vue?vue&type=template&id=643b3cb4"
import script from "./ExpertStatisticsTemplate.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script